// extracted by mini-css-extract-plugin
module.exports = {"sort":"US-z","sortSelect":"VS-z","disabled":"WS-z"};